'use strict';

module.exports = {
  add: require('./add'),
  addSection: require('./addSection'),
  addpage: require('./addpage'),
  amindBoundary: require('./amindBoundary'),
  amindDownload: require('./amindDownload'),
  amindHotkey: require('./amindHotkey'),
  amindRelation: require('./amindRelation'),
  amindShare: require('./amindShare'),
  amindSmile: require('./amindSmile'),
  amindSubTheme: require('./amindSubTheme'),
  amindSummary: require('./amindSummary'),
  amindTheme: require('./amindTheme'),
  amindUndo: require('./amindUndo'),
  arrow: require('./arrow'),
  autoLayout: require('./autoLayout'),
  blockDisable: require('./blockDisable'),
  blockEnable: require('./blockEnable'),
  'block-show': require('./blockShow'),
  'block-hidden': require('./blockHidden'),
  'checkbox-active': require('./checkbox-active'),
  'checkbox-normal': require('./checkbox-normal'),
  checkbox: require('./checkbox'),
  clear: require('./clear'),
  clone: require('./clone'),
  close: require('./close'),
  datapool: require('./datapool'),
  date: require('./date'),
  dialog: require('./dialog'),
  doubt: require('./doubt'),
  download: require('./download'),
  'drag-handler': require('./drag-handler'),
  drag: require('./drag'),
  edit: require('./edit'),
  error: require('./error'),
  exit: require('./exit'),
  expand: require('./expand'),
  forward: require('./forward'),
  fullscreen: require('./fullscreen'),
  fullscreenexit: require('./fullscreenexit'),
  global: require('./global'),
  hidden: require('./hidden'),
  history: require('./history'),
  html: require('./html'),
  info: require('./info'),
  js: require('./js'),
  keymap: require('./keymap'),
  loading: require('./loading'),
  magicStick: require('./magicStick'),
  metadataField: require('./metadataField'),
  metadataFieldExtends: require('./metadataFieldExtends'),
  metadataFieldset: require('./metadataFieldset'),
  minus: require('./minus'),
  mobile: require('./mobile'),
  more: require('./more'),
  more2: require('./more2'),
  nonselected: require('./nonselected'),
  noradio: require('./noradio'),
  outline: require('./outline'),
  page: require('./page'),
  pc: require('./pc'),
  plus: require('./plus'),
  popup: require('./popup'),
  'position-top': require('./positionTop'),
  'position-bottom': require('./positionBottom'),
  'position-left': require('./positionLeft'),
  'position-right': require('./positionRight'),
  preview: require('./preview'),
  'radio-active': require('./radio-active'),
  'radio-normal': require('./radio-normal'),
  radio: require('./radio'),
  remove: require('./remove'),
  save: require('./save'),
  search: require('./search'),
  section: require('./section'),
  selection: require('./selection'),
  setting: require('./setting'),
  show: require('./show'),
  'sort-handler': require('./sort-handler'),
  success: require('./success'),
  switch: require('./switch'),
  triangle: require('./triangle'),
  unknow: require('./unknow'),
  upload: require('./upload'),
  var: require('./var'),
  warn: require('./warn'),
  'zoom-in': require('./zoom-in'),
  'zoom-out': require('./zoom-out'),
  delete: require('./delete'),
  rhino: require('./rhino')
};


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/index.js
// module id = 136
// module chunks = 0